import { useMemo } from "react";
import useClientAltAssets from "./useClientAltAssets";
import useClientDashboard from "./useClientDashboard";
export default function useClientAccounts(clientId, authConfig, preFetch = false) {
    const dashboard = useClientDashboard(clientId, authConfig, preFetch, {
        // Plaid accounts are loaded async so we want to be aggressive in refreshing them
        staleTime: 0,
    });
    const altAssets = useClientAltAssets(clientId, authConfig, preFetch);
    const result = useMemo(() => {
        if (preFetch) {
            return {
                data: undefined,
                isLoading: true,
                hasError: false,
                preFetch: dashboard.preFetch,
            };
        }
        if (dashboard.isLoading || dashboard.hasError) {
            return dashboard;
        }
        if (altAssets.isLoading || altAssets.hasError) {
            return altAssets;
        }
        return {
            data: {
                fartherAccounts: dashboard.data.accountDetails,
                externalAccounts: dashboard.data.externalAccountDetails.accounts,
                alternativeAssets: altAssets.data,
                externalLinks: dashboard.data.externalAccountDetails.links,
            },
            isLoading: dashboard.isLoading,
            hasError: dashboard.hasError,
            preFetch: dashboard.preFetch,
        };
    }, [altAssets, preFetch, dashboard]);
    return result;
}
//# sourceMappingURL=useClientAccounts.js.map